import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-theme"]

import "../public/fonts/stylesheet.scss";
import { useRoute } from "vue-router";
import { computed } from "vue";
import PaymentModal from "@/components/PaymentModal.vue";
import LanguageSwitcher from "@/components/base/LanguageSwitcher.vue";
import { useStore } from "@/store";
import BaseModal from "@/components/base/BaseModal.vue";
import { ModalConfigStruct } from "@/struct/ui/UIModalStruct";
import { useAppViewport } from "@/composables/useAppViewport";
import { useRouteTransition } from "@/composables/useRouteTransition";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const store = useStore();

// Держит --app-height / --keyboard-inset в актуальном состоянии для всего приложения.
useAppViewport();

// Направление перехода между страницами: вперёд / назад.
const routeTransition = useRouteTransition();

const layoutComponent = computed(() => {
  return route.meta.layout || "main-layout";
});

const showPaymentModal = computed(() => store.state.system.showPaymentModal);

const closePaymentModal = () => {
  store.dispatch("system/togglePaymentModal", false);
};

const brandId = computed(() => store.state.brand.operatorSource);

const modalConfig = computed<ModalConfigStruct | null>(
  () => store.state.system.activeConfig
);

const closeModal = () => store.dispatch("system/closeModal");

const handleAction = () => {
  if (modalConfig.value?.onAction) modalConfig.value.onAction();
  closeModal();
};

const handleSecondaryAction = () => {
  if (modalConfig.value?.onSecondaryAction)
    modalConfig.value.onSecondaryAction();
  closeModal();
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "root",
    "data-theme": brandId.value
  }, [
    _createVNode(LanguageSwitcher, { "is-visible": false }),
    (_openBlock(), _createBlock(_resolveDynamicComponent(layoutComponent.value), null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component, route }) => [
            _createVNode(_Transition, {
              name: _unref(routeTransition),
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("div", {
                  key: route.path,
                  class: "page-transition"
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                ]))
              ]),
              _: 2
            }, 1032, ["name"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (modalConfig.value)
          ? (_openBlock(), _createBlock(BaseModal, _mergeProps({ key: 0 }, modalConfig.value, {
              onClose: closeModal,
              onAction: handleAction,
              onSecondaryAction: handleSecondaryAction
            }), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(PaymentModal, {
      "show-modal": showPaymentModal.value,
      onClose: closePaymentModal
    }, null, 8, ["show-modal"])
  ], 8, _hoisted_1))
}
}

})